export default (messages, indexes) => {
  console.log('== MessageModule action `DELETE_DEPTH_COMPONENT` ==')
    const { message_index_dragged, row_index_dragged } = indexes

    messages = messages.map((message, i) => {
      if (message_index_dragged === i) {
        console.log('message_index_dragged !!')
        message = ((message, row_index) => {
          const { rows } = message
          return {
            ...message,
            rows: rows ? rows.filter((row, i) => (i !== row_index)) : []
          }
        })(message, row_index_dragged)
        console.log('Result message :', message)
      }
      return message
    })

    // length === 0 check
    if (messages.length === 0) {
      messages = null
    }
    console.log('Result messages :', messages)
    return messages
}